// /catalogue — public research catalogue (Feb 29, 2026 pivot).
//
// New model:
//   - This is the DEFAULT LANDING SURFACE. Doctors send patients
//     directly here to browse and order compounds. `/` and /research
//     both redirect to /catalogue.
//   - No `researchAccess` gate. Any visitor (anonymous or authed) sees
//     the full catalogue immediately.
//   - First-visit attestation modal blocks the page until the visitor
//     acknowledges age (18+) and research-purposes-only usage. Persisted
//     in localStorage per-device — click-through UX, not user data.
//   - Anonymous "+ ADD TO PLAN" writes into the anonymous tray
//     (BE `/tray/anon/<uuid>` — already wired via applicationTray.js).
//     Checkout still requires sign-in via the existing Plan flow.
//
// The clinical-supervision / employer-sponsored VOYA9 model lives
// separately at /for-employers.
import { useState } from "react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import ResearchHero from "@/components/research/ResearchHero";
import ResearchLegalNotice from "@/components/research/ResearchLegalNotice";
import ResearchCatalog from "@/components/research/ResearchCatalog";
import ComplianceBlock from "@/components/research/ComplianceBlock";
import CatalogueAttestation, { hasAttested } from "@/components/research/CatalogueAttestation";
import { C } from "@/lib/brand";
import { RESEARCH_NAVY_DEEP } from "@/components/research/ResearchHero";

export default function Catalogue() {
  // Attestation state: starts as whatever's in localStorage. First-time
  // visitors see the modal; returning visitors on the same device pass
  // straight through.
  const [attested, setAttested] = useState(() => hasAttested());
  const [labCopy, setLabCopy] = useState(null);

  if (!attested) {
    return <CatalogueAttestation onAcknowledge={() => setAttested(true)} />;
  }

  return (
    <div data-testid="catalogue-page" style={{ background: C.cream, minHeight: "100vh" }}>
      <PublicNav variant="light" />
      <ResearchHero qualityLine={labCopy?.qualityLine} supplierLine={labCopy?.supplierLine} />
      <ResearchLegalNotice />
      <ResearchCatalog onLabCopy={setLabCopy} />
      <ComplianceBlock labCopy={labCopy} />
      <Footer prevColor={RESEARCH_NAVY_DEEP} wedgeDir="left" />
    </div>
  );
}
